// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1iRUV","name":"Header_name__2Wic0","birthday":"Header_birthday__f4iJG","skeleton":"Header_skeleton__7uoEz"};